import type { NextPage } from "next"
import { useRouter } from "next/router"

import { Loading } from "~/components/Loading"

import type { ErrorFallback } from "./withErrorFallback"
import { withErrorFallback } from "./withErrorFallback"

export function withLoadingFallback<P extends Record<string, unknown>>(
  Component: NextPage<P>,
): ErrorFallback<P> {
  return withErrorFallback((props: P) => {
    const router = useRouter()

    if (router.isFallback) {
      return <Loading fullScreen />
    }

    return <Component {...props} />
  })
}
